import { PRICE_TITLE, HOME_2023_TITLE } from '@/common/constants';

const routes = [
  {
    path: '/m/home',
    name: 'm-home',
    components: {
      default: () => import('@/views/homeV2/mIndex.vue'),
      top: () => import('@/views/homeV2/components/HomeOperationRoute.vue'),
    },
    props: {
      top: { mobile: true },
    },
    meta: {},
  },
  {
    path: '/m/2023/home',
    name: 'm-home2023',
    component: () => import('@/views/home2023/mIndex.vue'),
    meta: {
      title: HOME_2023_TITLE,
    },
  },
  {
    path: '/m/help',
    name: 'm-help',
    component: () => import('@/views/help/mIndex.vue'),
    meta: {},
  },
  {
    path: '/m/helplist',
    name: 'm-helplist',
    component: () => import('@/views/help/HelpList.vue'),
    meta: {},
  },
  {
    path: '/m/price',
    name: 'm-price',
    component: () => import('@/views/price/src/Index.vue'),
    meta: {
      title: PRICE_TITLE,
    },
  },
  {
    path: '/m/case',
    name: 'm-case',
    component: () => import('@/views/case/src/Index.vue'),
    meta: {},
  },
  {
    path: '/m/download',
    name: 'm-download',
    redirect: '/m/home',
  },
  {
    // K12人工智能教学
    path: '/m/k12-ai-teaching',
    name: 'm-k12-ai-teaching',
    component: () => import('@/views/k12-ai-teaching/mIndex.vue'),
    meta: {},
  },
  {
    // 高校人才培养
    path: '/m/college-talent-training',
    name: 'm-college-talent-training',
    component: () => import('@/views/college-talent-training/mIndex.vue'),
    meta: {},
  },
];

export default routes;
